// Quick date-range presets and the helpers that resolve a preset into a
// { from, to } range, used by the RangeFilters component.
const pad = (n) => String(n).padStart(2, '0');

// Parse a 'YYYY-MM-DD' string into a local Date (avoids UTC shift).
function parseYmd(s) {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
}

// Quick date-range presets (relative to the latest available data).
export const RANGE_PRESETS = [
  { key: '1m', label: '1M', months: 1 },
  { key: '3m', label: '3M', months: 3 },
  { key: '6m', label: '6M', months: 6 },
  { key: '1y', label: '1Y', months: 12 },
];

// { from, to } for a preset = the last N months of data, anchored to `anchorMax`
// (the latest date that has data), falling back to today.
export function presetRange(months, anchorMax) {
  const anchor = anchorMax ? parseYmd(anchorMax) : new Date();
  const fromDate = new Date(anchor);
  fromDate.setMonth(fromDate.getMonth() - months);
  const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  return { from: ymd(fromDate), to: anchorMax || ymd(anchor) };
}

// 'YYYY-MM-DD' → "Jul 4" for a clean, compact daily x-axis tick.
export function dayTickLabel(ymd) {
  const [y, m, d] = ymd.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
// Display a breakdown period by grouping: day 'YYYY-MM-DD' → "10 Jun",
// month 'YYYY-MM' → "Jun 2026", year 'YYYY' → "2026".
export function periodDisplay(period, granularity) {
  if (!period) return period;
  if (granularity === 'year') return period;
  const p = period.split('-');
  if (granularity === 'month') return `${MONTHS[Number(p[1]) - 1]} ${p[0]}`;
  return `${Number(p[2])} ${MONTHS[Number(p[1]) - 1]}`;
}

// { from, to } for the last `days` days of data (inclusive), anchored to the latest
// date. This is the default window pages open on, and where deselecting a preset resets to.
export function lastDaysRange(days, anchorMax) {
  const anchor = anchorMax ? parseYmd(anchorMax) : new Date();
  const start = new Date(anchor);
  start.setDate(start.getDate() - (days - 1));
  const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  return { from: ymd(start), to: anchorMax || ymd(anchor) };
}
